// Back in stock (snippets/back-in-stock.liquid, owner 2026-10-23): shows on sold-out variants only, follows variant
// changes, sends the email in a POST body to the app proxy, and lists 2-3 similar products available in the same size.
(() => {
  if (customElements.get('back-in-stock')) return;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const money = (cents, currency) => new Intl.NumberFormat(document.documentElement.lang || 'it', { style: 'currency', currency }).format(cents / 100);
  const esc = (s) => String(s ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  class BackInStock extends HTMLElement {
    connectedCallback() {
      this.t = JSON.parse(this.querySelector('[data-bis-i18n]').textContent);
      this.form = this.querySelector('[data-bis-form]');
      this.msg = this.querySelector('.bis__msg');
      this.querySelector('[data-bis-open]').addEventListener('click', () => {
        this.form.hidden = false;
        this.querySelector('[data-bis-open]').hidden = true;
        this.form.email.focus();
      });
      this.form.addEventListener('submit', (e) => { e.preventDefault(); this.send(); });
      this.update(this.dataset.variant, this.dataset.available === 'true');
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsub = subscribe(PUB_SUB_EVENTS.productVariantChange, (data) => {
          if (data?.variant) this.update(String(data.variant.id), data.variant.available, data.variant);
        });
      }
    }
    disconnectedCallback() { this.unsub?.(); }

    update(id, available, variant) {
      this.dataset.variant = id;
      this.hidden = !!available;
      this.form.hidden = true;
      this.msg.hidden = true;
      this.querySelector('[data-bis-open]').hidden = false;
      if (!available) this.alternatives(variant);
    }

    async send() {
      const email = this.form.email.value.trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) return this.say(this.t.invalid);
      const btn = this.form.querySelector('button[type=submit]');
      btn.disabled = true;
      try {
        const r = await fetch('/apps/ordine/stock', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ variant: this.dataset.variant, product: this.dataset.product, email, marketing: this.form.marketing.checked, locale: this.dataset.locale }),
        });
        const data = await r.json().catch(() => ({}));
        this.say(r.ok ? (data.already ? this.t.already : this.t.ok) : this.t.error, r.ok);
      } catch { this.say(this.t.error); }
      btn.disabled = false;
    }

    say(text, ok) {
      this.msg.textContent = text;
      this.msg.classList.toggle('is-ok', !!ok);
      this.msg.hidden = false;
    }

    // Similar products available now in the same size (size option detected in Liquid), max 3.
    async alternatives(variant) {
      const box = this.querySelector('[data-bis-alts]');
      const list = this.querySelector('[data-bis-list]');
      const idx = this.dataset.sizeIndex === '' ? -1 : Number(this.dataset.sizeIndex);
      let size = null;
      if (idx >= 0) {
        size = variant?.options?.[idx] ?? null;
        if (!size) {
          const sel = document.querySelectorAll('variant-selects fieldset, variant-radios fieldset')[idx];
          size = sel?.querySelector('input:checked')?.value ?? null;
        }
      }
      try {
        const r = await fetch(`${root}recommendations/products.json?product_id=${this.dataset.product}&limit=10&intent=related`);
        const data = await r.json();
        const norm = (s) => String(s || '').trim().toLowerCase();
        const picks = [];
        // Same product type first (knee guards before elbow guards), then the rest, keeping Shopify's order.
        const type = norm(this.dataset.type);
        const ranked = [...(data.products || [])].sort((a, b) => (norm(b.type) === type) - (norm(a.type) === type));
        for (const p of ranked) {
          if (!p.available) continue;
          let v = null;
          if (size) {
            const sizeOpt = (p.options || []).findIndex((o) => /tagli|size|größe|grösse|taille|talla|rozmiar|misura/i.test(o.name || o));
            if (sizeOpt < 0) continue;
            v = p.variants.find((x) => x.available && norm(x.options[sizeOpt]) === norm(size));
            if (!v) continue;
          } else {
            v = p.variants.find((x) => x.available);
          }
          picks.push({ p, v });
          if (picks.length === 3) break;
        }
        if (!picks.length) { box.hidden = true; return; }
        const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
        list.innerHTML = picks.map(({ p, v }) => {
          const img = p.featured_image ? `${p.featured_image}${p.featured_image.includes('?') ? '&' : '?'}width=160` : '';
          return `<a class="bis__alt" href="${esc(p.url)}?variant=${v.id}">${img ? `<img src="${esc(img)}" alt="" width="64" height="64" loading="lazy">` : ''}<span class="bis__alt-text"><span class="bis__alt-title">${esc(p.title)}</span><span class="bis__alt-meta">${size ? `${esc(this.t.size)} ${esc(size)} · ` : ''}${money(v.price, currency)}</span></span></a>`;
        }).join('');
        box.hidden = false;
      } catch { box.hidden = true; }
    }
  }
  customElements.define('back-in-stock', BackInStock);
})();
